var overflowFade = {
  showMore       : function(moreButton) {
    var wrapper                                                             = moreButton.closest('.overflow-fade-wrapper');
    wrapper.getElementsByClassName('overflow-fade-inner-elem')[0].classList = 'overflow-fade-inner-elem';
    moreButton.style                                                        = 'display: none;';
    wrapper.getElementsByClassName('overflow-fade-show-less')[0].style      = 'display: inline;';
  },
  showLess       : function(lessButton) {
    var wrapper                                                             = lessButton.closest('.overflow-fade-wrapper');
    var origHeight                                                          = wrapper.offsetHeight;
    wrapper.getElementsByClassName('overflow-fade-inner-elem')[0].classList = 'overflow-fade-inner-elem overflow-fade-content';
    lessButton.style                                                        = 'display: none;';
    wrapper.getElementsByClassName('overflow-fade-show-more')[0].style      = 'display: inline;';
    overflowFade.getScrollParent(lessButton).scrollBy(0, wrapper.offsetHeight - origHeight);
  },
  init           : function(elem) {
    var wrapper       = document.createElement('div');
    wrapper.classList = "overflow-fade-wrapper";
    elem.parentNode.insertBefore(wrapper, elem);


    wrapper.innerHTML = '<div class="overflow-fade-wrapper">' +
                        '<div class="overflow-fade-inner-elem overflow-fade-content">' +
                        '</div>' +
                        '<div class="overflow-fade-button-wrapper">' +
                        '<button onclick="overflowFade.showMore(this)" class="btn btn-info overflow-fade-show-more" style="display: inline;">' +
                        'Show more...' +
                        '</button>' +
                        '</div>' +
                        '<a href="javascript:void(0);" class="overflow-fade-show-less" style="display: none;" onclick="overflowFade.showLess(this)">' +
                        'Show less...' +
                        '</a>' +
                        '</div>';

    wrapper.getElementsByClassName("overflow-fade-content")[0].appendChild(elem);

  },
  getScrollParent: function(node) {
    if (node == null) {
      return null;
    }

    if (node.scrollHeight > node.clientHeight) {
      return node;
    }
    else {
      return overflowFade.getScrollParent(node.parentNode);
    }
  }
};




